import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Pagination, Select, Button, Spin, message } from 'antd'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import SearchField from '../../home/components/filters/SearchField'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'
import CombinedSetStatisticsTable from './CombinedSetStatisticsTable'
import { basketItemHistory } from '../../../services/api/mergerApi'
import { exportBasketItemHistory } from '../../../services/api/3dApi'
import { createJobExport } from '../../../helpers/createJobExport'

const CombinedSetStatisticsPage = () => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [searchBarcode, setSearchBarcode] = useState('')
    const [typeAction, setTypeAction] = useState('all')
    const [time, setTime] = useState({})
    const [loading, setLoading] = useState(false)

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const _handleFilter = (field, value) => {
        if (field === "searchBarcode") setSearchBarcode(value)
        if (field === "typeAction") setTypeAction(value)
        if (field === "time") setTime(value)

        setPage(1)
    }

    const _fetchData = async () => {
        setLoading(true)
        setError('')
        try {
            const payload = {
                page, limit
            }
            if (!!searchBarcode) payload.order_numbers = searchBarcode.startsWith("#") ? searchBarcode.replace("#", "") : searchBarcode
            if (!!typeAction) payload.action_types = typeAction === "all" ? "add_set_item_to_basket, remove_set_item_from_basket" : typeAction
            if (!!time && !!time.from && !!time.to) payload.created_at = time

            const { data: res } = await basketItemHistory(payload)
            const { data, success, message: mess } = res
            if (!success) throw new Error(mess)

            const { basketItemHistories = [], total: newTotal = 0 } = { ...data }
            setTotal(newTotal)
            setData(basketItemHistories)

        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    const _handleExport = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {}
            if (!!searchBarcode) payload.order_numbers = searchBarcode.startsWith("#") ? searchBarcode.replace("#", "") : searchBarcode
            if (!!typeAction) payload.action_types = typeAction === "all" ? "add_set_item_to_basket, remove_set_item_from_basket" : typeAction
            if (!!time && !!time.from && !!time.to) payload.created_at = time

            const { data: res } = await exportBasketItemHistory(payload)
            if (typeof res !== 'string') {
                const { success, message: mess, data } = res
                if (!success) throw new Error(mess)

                if (Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            } else {
                if (res) downloadFileFromData(res, { filename: `set-basket-item-histories-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

        } catch (e) {
            setError(e.message)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        _fetchData()
    }, [page, limit, searchBarcode, typeAction, time])

    return (
        <div className='CombinedSetStatisticsPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Thống kê gộp SET</h3>
                        <div className='d-flex align-items-center'>
                            <Link
                                className='ant-btn ml-3 ant-btn-primary'
                                to='merger-set'
                                disabled={loading}
                            >
                                Giỏ gộp SET
                            </Link>
                            <Button
                                className='ant-btn ml-3'
                                onClick={_handleExport}
                                disabled={loading}
                            >
                                Export
                            </Button>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-2'>
                                <label className='font-weight-bold mb-1'>Mã đơn:</label>
                                <SearchField
                                    field='searchBarcode'
                                    placeholder='Tìm theo mã đơn...'
                                    onChangeInput={_handleFilter}
                                />
                            </div>

                            <div className='col-2'>
                                <label for="request_update"
                                    className="d-block w-100 font-weight-bold mb-1">Loại thao tác</label>
                                <Select
                                    name='typeAction'
                                    className='typeAction'
                                    onChange={(value) => _handleFilter("typeAction", value)}
                                    value={typeAction}
                                    showArrow
                                    style={{ width: '100%' }}
                                >
                                    <Select.Option value='all'>All</Select.Option>
                                    <Select.Option value='add_set_item_to_basket'>Thêm item vào giỏ</Select.Option>
                                    <Select.Option value='remove_set_item_from_basket'>Xóa giỏ</Select.Option>
                                </Select>
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <label className="font-weight-bold mb-1">Thời gian:</label>
                                <FilterDateRangeV2
                                    field='time'
                                    onDatesChange={(_, value) => _handleFilter("time", value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <CombinedSetStatisticsTable
                            data={data}
                            loading={loading}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default CombinedSetStatisticsPage